import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Calendar, RefreshCw, Sun } from 'lucide-react';
const steps = [{
  day: 'Sábado de Preparación',
  desc: 'Limpiamos tus reservas de glucógeno con el orden de alimentos correcto.',
  icon: Calendar
}, {
  day: 'Domingo de Reset',
  desc: 'Aplicamos el protocolo de inundación de nutrientes y drenaje linfático suave.',
  icon: RefreshCw
}, {
  day: 'Lunes de Resultados',
  desc: 'Despiertas sintiéndote ligera, con el abdomen plano y claridad mental.',
  icon: Sun
}];
export function HowItWorks() {
  return <section className="py-16 md:py-24 px-6 bg-white/50" data-id="element-111">
      <div className="max-w-4xl mx-auto" data-id="element-112">
        <FadeIn data-id="element-113">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-charcoal" data-id="element-114">
            Así funciona tu fin de semana de transformación
          </h2>
        </FadeIn>

        <div className="relative" data-id="element-115">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-sage/20 -z-10" data-id="element-116"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-117">
            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative flex flex-col items-center text-center" data-id="element-118">
                <div className="w-24 h-24 rounded-full bg-cream border-4 border-white shadow-md flex items-center justify-center mb-6 z-10" data-id="element-119">
                  <step.icon className="w-10 h-10 text-terracotta" data-id="element-120" />
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-3 font-playfair" data-id="element-121">
                  {step.day}
                </h3>
                <p className="text-warmgray leading-relaxed" data-id="element-122">{step.desc}</p>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}